import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  FormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FileUploadComponent } from '../../util/upload/file-upload.component';
import * as _ from 'lodash';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { DynamicFormEmbedComponent } from '../../util/dynamic-form-embed/dynamic-form-embed.component';
import {
  DynamicFormConfigurationView,
  DynamicFormView,
  EDynamicFormInputType,
  EDynamicFormSource,
} from '../../models/DynamicFormView';
import { NgxMaskConfig } from 'ngx-mask';

import { UtilityService } from '../../service/utility.service';
import { NotificationService } from '../../service/notification.service';
import { LoadingService } from '../../service/loading.service';
import Swal from 'sweetalert2';
import { VendorInformationChangeRequest } from '../../models/VendorInformationChangeRequest';
import { VendorInformationChangeRequestService } from '../../service/vendor-information-change-request.service';
import { DocumentView } from '../../models/form/DocumentView';
const maskConfig: Partial<NgxMaskConfig> = {
  validation: true,
  dropSpecialCharacters: false,
};

@Component({
  selector: 'app-information-change-request',
  standalone: true,
  imports: [
    NgxMaskDirective,
    DynamicFormEmbedComponent,
    FormsModule,
    FileUploadComponent,
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  templateUrl: './information-change-request.component.html',
  styleUrls: ['./information-change-request.component.css'],
})
export class InformationChangeRequestComponent implements OnInit {
  @ViewChild('documentsSection') documentsSection: ElementRef;
  form: FormGroup;
  statusform: FormGroup;
  contactForm: FormGroup;
  submitted = false;
  Status: string;
  CompletionDate: any;
  files: any[] = [];
  uploadedFiles: File[] = [];
  submittedContent = false;
  Contacts: any[] = [];
  isDocumentDeleted: any = false;
  deletedDocumentIds: string[] = [];
  vendorid: string[] = [];
  isCardBodyVisible = false;
  isEditing!: Boolean;
  item: VendorInformationChangeRequest;
  id!: string;
  readonly clientId!: string;
  additionaFields!: DynamicFormView;
  sourceId: number = EDynamicFormSource.VendorForm;
  prefixLabel: string = '';
  canEdit: Boolean;
  currentStep: string;
  isRejected: boolean;
  canSubmit: boolean = true;
  constructor(
    private formBuilder: FormBuilder,
    public utilityService: UtilityService,
    private notificationService: NotificationService,
    private VendorInformationChangeRequestService: VendorInformationChangeRequestService,
    private spinner: LoadingService,
    private loadingService: LoadingService,
  ) {
    this.contactForm = this.formBuilder.group({
      id: ['00000000-0000-0000-0000-000000000000'],
      contactName: [null, Validators.required],
      phone: [null, Validators.required],
      emailAddress: [null, [Validators.email, Validators.required]],
    });

    this.form = this.formBuilder.group({
      id: ['00000000-0000-0000-0000-000000000000'],
      Name: [null, Validators.required],
      LegalName: [null, Validators.required],
      Address: [null, [Validators.maxLength(250), Validators.required]],
      AddressLine2: [null, Validators.maxLength(100)],
      isInternational: [false],
      City: [null, [Validators.maxLength(100), Validators.required]],
      State: ['AL', [Validators.required]],
      ZipCode: [null, [Validators.maxLength(10), Validators.required]],
      Description: [null],
      W9Status: ['Yes'],
      FutureBidStatus: [null],
      W9StatusReason: [null],
      VendorType: [null],
      TradeBusinessEngaged: [null],
      ReceivesRentOrRoyaltyIncome: [null],
      ApplicableTaxIdentificationNumber: [null],
      SocialSecurityNumber: [null],
      EmployerIdentificationNumber: [null],
      Form1099Applicable: ['0'],
      paymentType: [''],
      deliveryMethod: ['Email', Validators.required],
      Form1099ApplicableOther: [null],
      IsIncorporated: [null],
      corporationType: [null],
      VendorDepartments: [null],
      OfferEarlyPaymentDiscount: [null],
      EarlyPaymentDiscountDescription: [null],
      Contacts: [null],
      PayViaACH: [null],
      BankName: [null],
      BankRoutingNumber: [null],
      BankAccountNumber: [null],
      BankAccountType: [null],
      BankAccountClass: [null],
      DigitalCheckEmailAddress: [null],
      ProvidesMerchandiseOrUtilities: [false],
      MinorityBusinessEnterprise: [false],
      requestedBy: ['system'],
      vendorW9File: new FormControl(null),
      voidedCheckFile: new FormControl(null),
      projectAgreement: new FormControl(null),
      attachments: new FormArray([]),
      MedicalLegalServicesStatus: [null],
      ExistingBusinessRelation: [null],
      isDraft: [true],
      additionalFieldValues: [null],
      vendorId: [null],
    });

    this.statusform = this.formBuilder.group({
      vendorId: ['00000000-0000-0000-0000-000000000000'],
    });
  }

  setVendorW9FileValidator(status: string) {
    const vendorW9FileControl = this.form.get('vendorW9File');
    if (status === 'Yes') {
      vendorW9FileControl?.setValidators([Validators.required]);
    } else {
      vendorW9FileControl?.clearValidators();
    }
    vendorW9FileControl?.updateValueAndValidity();
  }

  ngOnInit() {
    const OldData = JSON.parse(
      localStorage.getItem('registrationData') || '{}',
    );

    if (OldData) {
      this.changeRequestForm(OldData);
      this.id = OldData.id;
    }

    this.form.get('W9Status')!.valueChanges.subscribe((status: string) => {
      this.setVendorW9FileValidator(status);
    });

    this.statusform.get('vendorId')!.setValue(OldData.id);
    this.getFormStatus();

    const vendorId = JSON.parse(localStorage.getItem('vendorId') || 'null');
    this.VendorInformationChangeRequestService.getForm(vendorId).subscribe(
      (data: any) => {
        this.spinner.OnLoading.emit(false);
        localStorage.setItem('registrationData', JSON.stringify(data));
        this.changeRequestForm(data);
        this.form.get('VendorId')!.setValue(data.id);
        this.statusform.get('vendorId')!.setValue(data.id);
      },
      (err: any) => {
        this.spinner.OnLoading.emit(false);
        this.notificationService.showError(err, 'Error');
      },
    );
  }

  ngAfterViewInit(): void {}

  get f() {
    return this.form.controls;
  }

  get cf() {
    return this.contactForm.controls;
  }

  onSubmitContent() {
    this.submittedContent = true;
    if (this.contactForm.invalid) {
      this.utilityService.getFormValidationErrors(this.form);
      this.notificationService.showError('Fill all required fields', 'Error');
      return;
    }
    this.submittedContent = true;
    let request = _.cloneDeep(this.contactForm.value);
    let contactFormValue = this.contactForm.value;
    this.Contacts.push(request);
    this.reSetContactForm();
    (this.form.get('Contacts') as FormArray).push(
      this.formBuilder.group(contactFormValue),
    );
  }

  reSetContactForm() {
    this.contactForm.reset();
    this.contactForm
      .get('id')
      ?.setValue('00000000-0000-0000-0000-000000000000');
    this.submittedContent = false;
  }

  resetForm() {
    while (this.filesArray.length) {
      this.filesArray.removeAt(0);
    }
    this.form.reset();
  }

  removeContent(index: number) {
    this.Contacts.splice(index, 1);
    (this.form.get('Contacts') as FormArray).removeAt(index);
  }

  integrateAdditionalFields(event: any) {
    const values = event.values;
    if (values && values.length > 0) {
      values.forEach((value: any) => {
        this.form.addControl(
          value.tempLabel,
          new FormControl(value.value, value.validators),
        );
      });
      this.additionaFields = event.dynamicForm;
      this.prefixLabel = event.prefixLabel;

      if (this.isEditing) {
        this.disableAddtionalFields(true);
      }
    }
  }

  onDynamicformFileChange($event: any) {
    const control = this.form.get($event.propertyName);
    if (control) {
      if ($event.file) {
        control.patchValue($event.file);
      }
    } else {
      console.warn(`Form control ${$event.propertyName} not found.`);
    }
  }

  disableAddtionalFields(disable: boolean) {
    Object.keys(this.form.controls).forEach((controlName) => {
      if (controlName.includes(this.prefixLabel)) {
        disable
          ? this.form.controls[controlName].disable()
          : this.form.controls[controlName].enable();
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.Contacts.length > 0) {
      this.form.get('Contacts')?.setValue(this.Contacts);
    }

    if (this.form.invalid) {
      this.utilityService.getFormValidationErrors(this.form);
      this.notificationService.showError('Fill all required fields', 'Error');
      return;
    }
    this.assembleDataforSubmit();
    if (this.form.get('MedicalLegalServicesStatus')?.value == 'Yes') {
      this.form.get('Form1099Applicable')?.setValue('Form 1099-MISC');
    }
    let request = _.cloneDeep(this.form.value);
    let requestCall;
    this.spinner.OnLoading.emit(true);
    requestCall = this.VendorInformationChangeRequestService.createForm(
      request,
      this.prefixLabel,
    );
    requestCall.subscribe(
      (data: any) => {
        this.spinner.OnLoading.emit(false);
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Form saved successfully!',
        }).then(() => {
          window.location.reload();
        });
      },
      (err: any) => {
        this.spinner.OnLoading.emit(false);
        this.notificationService.showError(err, 'Error');
      },
    );
  }

  assembleDataforSubmit() {
    this.additionaFields?.dynamicFormConfigurations?.forEach(
      (config: DynamicFormConfigurationView) => {
        let value = this.form.get(config.tempLabel)?.value;

        config.value =
          config.dynamicFormInputTypeId === EDynamicFormInputType.FileInput
            ? config.tempLabel.slice(this.prefixLabel.length) +
              '--' +
              value.name
            : value;

        if (config.dynamicFormInputTypeId === EDynamicFormInputType.Dropdown) {
          config.optionId = value;
        }
      },
    );

    this.form.addControl(
      'additionalField',
      this.formBuilder.group({
        source: '',
        sourceId: 1,
        dynamicFormConfigurations: this.formBuilder.array([]),
      }),
    );

    this.additionaFields?.dynamicFormConfigurations?.forEach(
      (config: DynamicFormConfigurationView) => {
        let { dynamicFormConfigurationOptions, ...configWithoutOptions } =
          config;
        (
          this.form.get(
            'additionalField.dynamicFormConfigurations',
          ) as FormArray
        ).push(this.formBuilder.group(configWithoutOptions));
      },
    );
  }

  onAdditionalFileChanged(file: any, i: number) {
    let currentVal = this.filesArray.controls[i].value;
    currentVal.file = file;
    this.filesArray.controls[i].patchValue(currentVal);
  }

  onFileChange($event: any, propertyName: string) {
    this.files.push($event);
    this.form.get(propertyName)?.patchValue($event);
  }

  get filesArray(): FormArray {
    return this.form.controls['attachments'] as FormArray;
  }

  onFileSelected(event: any, fileInput: HTMLInputElement) {
    const selectedFiles = event.target.files;
    if (selectedFiles) {
      for (let i = 0; i < selectedFiles.length; i++) {
        let currentFileCount = this.filesArray.controls.length + 1;
        this.filesArray.push(
          new FormControl({
            label: `File ${currentFileCount}`,
            file: selectedFiles[i],
            order: currentFileCount,
          }),
        );
      }
    }

    fileInput.value = '';
  }

  removeFile(index: number) {
    if (this.filesArray.controls.length > 0) {
      this.filesArray.removeAt(index);
    }
  }

  private changeRequestForm(data: VendorInformationChangeRequest) {
    this.loadingService.OnLoading.emit(false);
    this.item = data;
    this.form.get('isDraft')!.setValue(data.isDraft);
    this.form.get('Name')!.setValue(data.name);
    this.form.get('LegalName')!.setValue(data.legalName);
    this.form.get('Address')!.setValue(data.address);
    this.form.get('AddressLine2')!.setValue(data.addressLine2);
    this.form.get('City')!.setValue(data.city);
    this.form.get('State')!.setValue(data.state);
    this.form.get('ZipCode')!.setValue(data.zipCode);
    this.form.get('Description')!.setValue(data.description);
    this.form.get('W9Status')!.setValue(data.w9Status);
    this.form.get('FutureBidStatus')!.setValue(data.futureBidStatus);
    this.form.get('W9StatusReason')!.setValue(data.w9StatusReason);
    this.form.get('TradeBusinessEngaged')!.setValue(data.tradeBusinessEngaged);
    let vendorId = JSON.parse(localStorage.getItem('vendorId') || '{}');
    this.statusform.get('vendorId')!.setValue(vendorId);
    this.form.get('vendorId')!.setValue(vendorId);
    this.form
      .get('ReceivesRentOrRoyaltyIncome')!
      .setValue(data.receivesRentOrRoyaltyIncome);
    this.form
      .get('ApplicableTaxIdentificationNumber')!
      .setValue(data.applicableTaxIdentificationNumber);
    this.form.get('SocialSecurityNumber')!.setValue(data.socialSecurityNumber);
    this.form
      .get('EmployerIdentificationNumber')!
      .setValue(data.employerIdentificationNumber);
    this.form.get('Form1099Applicable')!.setValue(data.form1099Applicable);
    this.form
      .get('Form1099ApplicableOther')!
      .setValue(data.form1099ApplicableOther);
    this.form.get('IsIncorporated')!.setValue(data.isIncorporated);
    this.form.get('corporationType')!.setValue(data.corporationType);
    this.form.get('VendorDepartments')!.setValue(data.vendorDepartments);
    this.form
      .get('MedicalLegalServicesStatus')!
      .setValue(data.medicalLegalServicesStatus);
    this.form.get('PayViaACH')!.setValue(data.payViaACH?.toString());
    this.form
      .get('ProvidesMerchandiseOrUtilities')!
      .setValue(data.providesMerchandiseOrUtilities?.toString());
    this.form.get('BankName')!.setValue(data.bankName);
    this.form.get('BankRoutingNumber')!.setValue(data.bankRoutingNumber);
    this.form.get('BankAccountNumber')!.setValue(data.bankAccountNumber);
    this.form.get('BankAccountType')!.setValue(data.bankAccountType);
    this.form.get('BankAccountClass')!.setValue(data.bankAccountClass);
    this.form
      .get('DigitalCheckEmailAddress')!
      .setValue(data.digitalCheckEmailAddress);
    this.form.get('VendorType')!.setValue(data.vendorType);
    this.form
      .get('MinorityBusinessEnterprise')!
      .setValue(data.minorityBusinessEnterprise?.toString());
    this.form
      .get('ExistingBusinessRelation')!
      .setValue(data.existingBusinessRelation?.toString());
    this.form.get('paymentType')!.setValue(data.paymentType);
    this.form.get('deliveryMethod')!.setValue(data.deliveryMethod);
    this.form
      .get('additionalFieldValues')!
      .setValue(data.additionalFieldValues);

    if (data.requestedBy) {
      this.form.get('requestedBy')!.setValue(data.requestedBy);
    }

    this.Contacts = data.contacts;
    this.item.documents = data.documents;

    this.isRejected =
      this.item.declinedReason != null && this.item.declinedReason.length > 0;
    let currentStep = this.item?.workflowSteps?.find((t) => t.isCurrent);
    if (currentStep != null) {
      this.currentStep = currentStep.name;
    }
  }

  getFormStatus() {
    let request = _.cloneDeep(this.statusform.value);
    this.spinner.OnLoading.emit(true);
    this.VendorInformationChangeRequestService.getFormStatus(
      request,
      this.prefixLabel,
    ).subscribe(
      (data: any) => {
        this.spinner.OnLoading.emit(false);
        const confirmationParts = data.confirmation.split(':');

        if (confirmationParts[0] === 'Vendor Change Request is Completed') {
          this.Status = 'Your Request is Completed';
          const dateTimeParts = confirmationParts[1].trim().split(' ');
          this.CompletionDate = dateTimeParts[0];
          this.canSubmit = true;
        } else if (
          data.confirmation === 'Vendor Change Request is In Progress'
        ) {
          this.Status = 'Your Request is In progress';
          this.canSubmit = false;
        } else {
          this.Status = 'No Request found';
          this.canSubmit = true;
        }
      },
      (err: any) => {
        this.Status = 'No Request found';
        this.notificationService.showError(err, 'Error');
      },
    );
  }
}
